import type { QrSummary } from './types';

export function qrHref(qr: Pick<QrSummary, 'code' | 'domain'>): string {
  const domain = qr.domain && qr.domain !== 'q-r.cl' ? `?domain=${encodeURIComponent(qr.domain)}` : '';
  return `/consola/qr/${encodeURIComponent(qr.code)}${domain}`;
}

export type QrImageVariant = 'primary' | 'fallback';
export type QrImageFormat = 'png' | 'svg';

export interface QrImageParams {
  variant?: QrImageVariant;
  format?: QrImageFormat;
  size?: number;
  download?: boolean;
}

function imageQuery(params: QrImageParams, extra: Record<string, string> = {}): string {
  const qs = new URLSearchParams(extra);
  qs.set('variant', params.variant ?? 'primary');
  qs.set('format', params.format ?? 'png');
  qs.set('size', String(params.size ?? 512));
  if (params.download) qs.set('download', '1');
  return `?${qs.toString()}`;
}

/** Imagen del QR para el partner: `GET /v1/qrs/{code}/image` (R14.1, R14.3). */
export function partnerQrImagePath(qr: Pick<QrSummary, 'code' | 'domain'>, params: QrImageParams = {}): string {
  const extra: Record<string, string> = qr.domain && qr.domain !== 'q-r.cl' ? { domain: qr.domain } : {};
  return `/v1/qrs/${encodeURIComponent(qr.code)}/image${imageQuery(params, extra)}`;
}

/** Imagen del QR para el operador: `GET /v1/operator/qrs/{id}/image` (R14.2). */
export function operatorQrImagePath(id: string, params: QrImageParams = {}): string {
  return `/v1/operator/qrs/${encodeURIComponent(id)}/image${imageQuery(params)}`;
}

export function shortLink(qr: Pick<QrSummary, 'code' | 'domain'>): string {
  return `https://${qr.domain || 'q-r.cl'}/${qr.code}`;
}

export function isHttpsUrl(value: string): boolean {
  try {
    const u = new URL(value.trim());
    return (u.protocol === 'https:' || u.protocol === 'http:') && Boolean(u.hostname.includes('.'));
  } catch {
    return false;
  }
}

export const ART_THEMES = [
  { id: 'fonda', label: 'Fonda dieciochera' },
  { id: 'cordillera', label: 'Cordillera' },
  { id: 'valparaiso', label: 'Puerto de Valparaíso' },
  { id: 'feria', label: 'Feria libre' },
  { id: 'desierto', label: 'Desierto florido' },
];
